<template>
  <div class="list-user admin-list-user admin_container_default">

    <PeriodSearchPanel
      panelTitle="詳細検索"
      :searchPeriods="[
        {
          label: '会員登録日',
          startDate: null,
          endDate: null,
          datePickerOptions: optionsDate
        },
        {
          label: 'ログイン日',
          startDate: null,
          endDate: null,
          datePickerOptions: optionsDate
        }
      ]"
      @search="($event) => getListUsers(1, $event)"
    ></PeriodSearchPanel>
  
    <div class="list-user-table p-0">
      <div class="mb-2 row p-0 admin_header">
        <div class="d-flex p-0 admin_title">
          <div class="text-truncate-mess header-font font-weight-bold">
            ユーザー管理
          </div>
        </div>
        <div class="row-input admin_center"></div>
        <div class="tex-left text-md-right text-sm-right admin_right">
          <button class="button-export-user" v-on:click="modalExportCSV()">
            ユーザーダウンロード
          </button>
          <button v-on:click="createUser()" class="button-create-user">
            新規追加
          </button>
          <button v-on:click="gotoDashboard()" class="button-back-dashboard">
            戻る
          </button>
        </div>
      </div>
      <!-- <div class="row">
        <div class="row-input col-sm-4 col-md-4 col-lg-3">
          <label
            class="w-100 font-weight-bold"
            style="padding-left: 40px; padding-right: 40px"
            >ユーザー名</label
          >
          <div class="cp-4 pr-0">
            <input class="form-control w-100" v-model="name" />
          </div>
        </div>
        <div class="row-input col-sm-4 col-md-4 col-lg-3 mx-4">
          <label
            class="w-100 font-weight-bold"
            style="padding-left: 40px; padding-right: 40px"
            >メールアドレス</label
          >
          <div class="cp-4 pr-0">
            <input class="form-control w-100" v-model="email" />
          </div>
        </div>
      </div> -->
      <div class="cp-4 w-50">
        <input
          class="form-control col-sm-12"
          v-model="keywords"
          style="height: 35px"
          placeholder="検索"
          @keydown.enter.prevent="getListUsers()"
        />
      </div>

      <!-- <div class="row">
        <div class="row-input col-sm-4 col-md-4 mb-3 mb-sm-0 col-lg-4">
          <label
            class="col-sm-12 font-weight-bold"
            style="padding-left: 40px; padding-right: 40px"
          >
            所持コンテンツ名
          </label>
          <div class="fd-admin-listproperty-card-filter filter-date cp-4 pr-0">
            <multiselect
              class="col-sm-12 col-lg-12 p-0"
              v-model="content_id"
              placeholder="購入付与スラグ追加"
              label="text"
              track-by="value"
              :options="listContentOptions"
              :multiple="true"
              :taggable="false"
                            :showNoResults="false"
              :select-label="'入力して選択する'"
              :deselect-label="'入力して削除する'"
              :selected-label="'選択された'"
              :loading="loadingContent"
              style=""
              v-bind:class="{ 'error-input': errorContentIdRequired }"
              @change="setOptionUser()"
              @open="clickScrollContent()"
            ></multiselect>
          </div>
        </div>
        <div class="row-input col-sm-4 col-md-4 mb-3 mb-sm-0 col-lg-4">
          <label
            class="col-sm-12 font-weight-bold"
            style="padding-left: 40px; padding-right: 40px"
          >
            所持スラグ名
          </label>
          <div class="fd-admin-listproperty-card-filter filter-date cp-4 pr-0">
            <multiselect
              v-model="slag_type_2"
              tag-placeholder="閲覧付与スラグを追加してください"
              class="col-sm-12 col-lg-12 px-0"
              placeholder="閲覧付与スラグを追加してください"
              label="slag_name_en"
              track-by="slag_name_en"
              :options="listSlagOptions"
              :multiple="true"
              :taggable="false"
                            :showNoResults="false"
              select-label="入力して選択する"
              selected-label="選択された"
              deselect-label="入力して削除する"
            >
              <template v-slot:no-options> リストは空です </template>
            </multiselect>
          </div>
        </div>
      </div> -->
      <!-- <div class="row">
        <div class="row-input col-sm-4 col-md-4 col-lg-3">
          <label
            class="w-100 font-weight-bold"
            style="padding-left: 40px; padding-right: 40px"
            >フリーワード</label
          >
          <div class="cp-4 pr-0">
            <input class="form-control w-100" v-model="freeword" />
          </div>
        </div>
      </div> -->
      <!-- <div class="d-flex justify-content-center mt-4 mb-4">
        <b-button
          v-on:click.prevent="getListUsers()"
          variant="info"
          class="mr-4"
          >絞り込み検索</b-button
        >
        <b-button
          variant="secondary"
          class="mr-4"
          v-on:click="resetFieldSearch()"
          >リセット</b-button
        >
      </div> -->
      <Tables :items="renderList" :fields="fields" :itemsPerPageSelect="{}">
        <template v-slot:page_content="{ item }">
          <td v-html="item.page_content"></td>
        </template>
        <template v-slot:id="{ index }">
          <td>{{ index + 1 }}</td>
        </template>
        <template v-slot:created_at="{ item }">
          <td>
            <div v-if="item.created_at !== null">
              {{
                new Date(item.created_at).toLocaleString("ja-JP", {
                  timeZone: "Asia/Tokyo",
                })
              }}
            </div>
          </td>
        </template>
        <template v-slot:logout_at="{ item }">
          <td>
            <div v-if="item.logout_at !== null">
              {{
                new Date(item.logout_at).toLocaleString("ja-JP", {
                  timeZone: "Asia/Tokyo",
                })
              }}
            </div>
          </td>
        </template>
        <template v-slot:name="{ item }">
          <td>
            <div v-if="item.name">
              {{ item.name }}
            </div>
            <div v-else></div>
          </td>
        </template>
        <template v-slot:action="{ item }">
          <td class="py-2 pl-2 pr-1 d-flex justify-content-center">
            <div class="w-5 d-flex align-items-center">
              <router-link
                :to="{
                  name: $route.params.shopId ? 'edit user' : 'edit user domain',
                  params: { shopId: $route.params.shopId, id: item.id },
                }"
                class="d-flex flex-column align-items-center"
              >
                <CButton
                  class="mx-1 btn-other bg-00ab82"
                  color="success"
                  square
                  v-on:click="getListUsers()"
                  variant="outline"
                  size="sm"
                  v-b-modal.modal-comfirm
                >
                  詳細確認
                </CButton>
              </router-link>
              <router-link
                :to="{
                  name: $route.params.shopId
                    ? 'purchase user'
                    : 'purchase user domain',
                  params: { id: item.id },
                  query: {
                    date_from: dateFromSend,
                    date_to: dateToSend,
                  },
                }"
                class="d-flex flex-column align-items-center"
              >
                <CButton
                  class="mx-1 btn-other bg-0076ba"
                  color="warning"
                  square
                  v-on:click="getListUsers()"
                  variant="outline"
                  size="sm"
                  v-b-modal.modal-comfirm
                >
                  購入履歴
                </CButton>
              </router-link>
            </div>
            <div class="d-flex align-items-center">
              <router-link
                :to="{
                  name: $route.params.shopId
                    ? 'ListUserNote'
                    : 'ListUserNote domain',
                  params: { id: item.id },
                }"
                class="d-flex flex-column align-items-center"
              >
                <CButton
                  class="mx-1 btn-other bg-f27200"
                  color="primary"
                  square
                  v-on:click="getListUsers()"
                  variant="outline"
                  size="sm"
                  v-b-modal.modal-comfirm
                >
                  ノート
                </CButton>
              </router-link>
              <router-link
                :to="{
                  name: $route.params.shopId
                    ? 'List chat user'
                    : 'List chat user domain',
                  params: { userId: item.id },
                }"
                class="d-flex flex-column align-items-center"
              >
                <CButton
                  class="mx-1 btn-other bg-d41876"
                  color="info"
                  square
                  variant="outline"
                  size="sm"
                >
                  質問機能
                </CButton>
              </router-link>
              <div class="d-flex flex-column align-items-center">
                <CButton
                  class="mx-1 btn-other btn-del"
                  color="danger"
                  square
                  v-on:click="showConfirm(item.id)"
                  variant="outline"
                  size="sm"
                  v-b-modal.delete-modal-user
                >
                  削除
                </CButton>
              </div>
            </div>
          </td>
        </template>
      </Tables>
      <div
        class="d-flex justify-content-center position-relative"
        v-if="listUser.total"
      >
        <p class="font-weight-bold">
          {{ listUser.total }}件中{{ listUser.data.length }}件を表示
        </p>
      </div>
      <div
        class="d-flex justify-content-center position-relative"
        v-if="listUser.last_page"
      >
        <CPagination
          v-if="listUser.total"
          :activePage.sync="page"
          :pages="listUser.last_page"
          align="center"
        />
        <!-- <div class="custom-selectLimitPage">
          <b-form-select
            v-model="limit"
            tag-placeholder="Add this as new category"
            :options="listLimitRecordPage"
            @change="changeLimitPage()"
          ></b-form-select>
        </div> -->
      </div>
    </div>
    <div>
      <b-modal id="delete-modal-user" hide-header hide-footer>
        <div class="d-block text-center">
          <h5>ブロックしてもよろしいですか？</h5>
        </div>
        <div class="d-flex justify-content-center">
          <b-button
            class="mx-2 mt-3 btn btn-danger"
            block
            v-on:click.prevent="blockNewUser()"
            >削除</b-button
          >
          <b-button
            class="mx-2 mt-3 btn btn-secondary"
            block
            @click="$bvModal.hide('delete-modal-user')"
          >
            キャンセル
          </b-button>
        </div>
      </b-modal>
    </div>
    <b-modal
      id="modal-export-user"
      size="lg"
      title="カテゴリを作成"
      hide-header
      hide-footer
    >
      <b-row class="p-4">
        <b-col md="12">
          <b-form-group label="ダウンロードを選択" v-slot="{ ariaDescribedby }">
            <b-form-radio
              v-model="selected"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              value="1"
              class="mt-4"
              >全ユーザーをダウンロード
            </b-form-radio>
            <b-row class="align-items-center mt-3">
              <b-col md="4">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="2"
                  >内容別
                </b-form-radio>
              </b-col>
              <b-col md="8" v-if="selected == 2">
                <multiselect
                  v-model="contentExport"
                  tag-placeholder="コンテンツ選択 "
                  placeholder="コンテンツ選択 "
                  label="text"
                  track-by="value"
                  :options="listContentOptions"
                  :multiple="true"
                  :taggable="true"
                  :close-on-select="false"
                >
                </multiselect>
              </b-col>
            </b-row>
            <b-row class="align-items-center mt-3">
              <b-col md="4">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="3"
                  >スラグで
                </b-form-radio>
              </b-col>
              <b-col md="8" v-if="selected == 3">
                <multiselect
                  v-model="slagExport"
                  tag-placeholder="スラグ選択"
                  placeholder="スラグ選択"
                  label="text"
                  track-by="value"
                  :options="listSlagOptions"
                  :multiple="true"
                  :taggable="true"
                  :close-on-select="false"
                >
                </multiselect>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
        <b-col class="d-flex justify-content-center">
          <button class="button-export-user" v-on:click="exportCSV()">
            CSV出力
          </button>
          <b-button variant="secondary" class="mr-4" v-on:click="returnList()">
            戻る
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Tables from "../../components/common/Tables";
import PeriodSearchPanel from "../../components/admin/PeriodSearchPanel";
import { tableFields } from "../../utils/table-fields.js";
import { Constants } from "../../utils/constants";
import { mapActions, mapGetters } from "vuex";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import $ from "jquery";
import "@fortawesome/fontawesome-free/css/fontawesome.css";
import "@fortawesome/fontawesome-free/css/regular.css";
import "@fortawesome/fontawesome-free/css/solid.css";
import Encoding from "encoding-japanese";
import { Urls } from "../../utils/urls.js";
import { Api } from "../../utils/http-common.js";

$.extend(true, $.fn.datetimepicker.defaults, {
  icons: {
    time: "far fa-clock",
    date: "far fa-calendar",
    up: "fas fa-arrow-up",
    down: "fas fa-arrow-down",
    previous: "fas fa-chevron-left",
    next: "fas fa-chevron-right",
    today: "fas fa-calendar-check",
    clear: "far fa-trash-alt",
    close: "far fa-times-circle",
  },
});
export default {
  name: "ListUser",
  data() {
    return {
      fields: tableFields.USER,
      listLimitRecordPage: [
        { value: 10, text: "10" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
        { value: 200, text: "200" },
      ],
      dataModal: "",
      name: "",
      keywords: "",
      email: "",
      dateRegis_from: "",
      dateRegis_to: "",
      dateLogout_from: "",
      dateLogout_to: "",
      limit: 10,
      page: 1,
      dateFromSend: "",
      dateToSend: "",
      listContentOptions: [],
      loadingContent: false,
      errorContentIdRequired: false,
      content_id: [],
      listSlagOptions: [],
      slag_type_2: [],
      freeword: null,
      listSlagSelect: [],
      listContentSelect: [],
      lengthList: null,
      shop_id: localStorage.getItem(Constants.SHOP_ID),
      optionsDate: {
        format: "YYYY-MM-DD HH:mm:ss",
        useCurrent: false,
        showClear: false,
        showClose: false,
        locale: "ja",
      },
      selected: 1,
      contentExport: [],
      slagExport: [],
    };
  },
  components: {
    Tables,
    PeriodSearchPanel
  },
  async created() {
    await this.getListUsers(1);
    this.lengthList = this.listUser.total;
    const requestContent = {
      data: {
        shop_id: this.shop_id,
      },
      page: 1,
    };
    this.getListContent(requestContent);
    this.getALLlistSlag(requestContent.data);
  },
  computed: {
    ...mapGetters([
      "listUser",
      "message",
      "success",
      "error",
      "listContent",
      "listSlag",
    ]),
    renderList() {
      if (this.listUser) {
        return this.listUser.data;
      }
      return [];
    },
  },
  watch: {
    success() {
      if (this.success) {
        this.$toasted.success(this.message);
        this.$store.commit("set", ["message", ""]);
        this.$store.commit("set", ["success", false]);
        this.getListUsers(this.page);
      }
    },
    error() {
      if (this.error) {
        this.$toasted.error(this.message);
        this.$store.commit("set", ["message", ""]);
        this.$store.commit("set", ["error", false]);
      }
    },
    listUser() {
      this.page = this.listUser.current_page;
    },
    page() {
      this.getListUsers(this.page);
    },
    listContent() {
      let listContent = [];
      listContent = this.listContent.data.map((item) => ({
        value: item.id,
        text: item.title,
      }));
      listContent.forEach((element) => {
        this.listContentOptions.push(element);
      });
      this.loadingContent = false;
    },
    listSlag() {
      this.listSlagOptions = this.listSlag.map((item) => ({
        value: item.id,
        text: item.slag_name ? item.slag_name : item.slag_name_en,
      }));
    },
  },
  methods: {
    ...mapActions({
      getListUser: "getListUser",
      destroyUserCDEA: "destroyUserCDEA",
      getListContent: "getListContent",
      getALLlistSlag: "getALLlistSlag",
    }),
    createUser() {
      this.$router.push({
        name: this.$route.params.shopId ? "create user" : "create user domain",
      });
    },
    showConfirm(id) {
      this.dataModal = id;
    },
    async getListUsers(page, searchPeriods) {
      // this.listContentSelect = [];
      // this.listSlagSelect = [];
      if (page === undefined) {
        page = this.page;
      }
      // if (this.slag_type_2 !== null) {
      //   this.slag_type_2.map((item) => {
      //     this.listSlagSelect.push(item.slag_id);
      //   });
      // }
      // if (this.content_id !== null) {
      //   this.content_id.map((item) => {
      //     this.listContentSelect.push(item.value);
      //   });
      // }

      if (searchPeriods) {
        this.dateRegis_from = searchPeriods[0].startDate;
        this.dateRegis_to = searchPeriods[0].endDate;

        this.dateLogout_from = searchPeriods[1].startDate;
        this.dateLogout_to = searchPeriods[1].endDate;
      }
    
      const formData = {
        page: page,
        data: {
          shop_id: this.shop_id,
          keywords: this.keywords,
          created_from: this.dateRegis_from,
          created_to: this.dateRegis_to,
          logout_from: this.dateLogout_from,
          logout_to: this.dateLogout_to,
          limit: this.limit,
          // slag_id: this.listSlagSelect,
          // content_id: this.listContentSelect,
        },
      };
      await this.getListUser(formData);
    },
    async blockNewUser() {
      const formBlock = {
        id: this.dataModal,
        shop_id: this.shop_id,
      };
      await this.destroyUserCDEA(formBlock);
      this.$nextTick(() => {
        this.$bvModal.hide("delete-modal-user");
      });
      this.getListUsers(this.page);
    },
    editUser(id) {
      this.$router.push({
        name: this.$route.params.shopId ? "edit user" : "edit user domain",
        params: { id: id },
      });
    },
    changeLimitPage() {
      this.getListUsers(1);
    },
    gotoDashboard() {
      if (this.$route.params.shopId) {
        this.$router.push({ name: "DashboardAdminBox" });
      } else {
        this.$router.push({ name: "DashboardAdminBox domain" });
      }
    },
    resetFieldSearch() {
      this.name = "";
      this.email = "";
      this.dateRegis_from = "";
      this.dateRegis_to = "";
      this.dateLogout_from = "";
      this.dateLogout_to = "";
      this.slag_type_2 = [];
      this.content_id = [];
      this.freeword = "";
      this.listSlagSelect = [];
      const formData = {
        page: 1,
        data: {
          shop_id: this.shop_id,
          name: this.name,
          email: this.email,
          created_from: this.dateRegis_from,
          created_to: this.dateRegis_to,
          logout_from: this.dateLogout_from,
          logout_to: this.dateLogout_to,
          limit: this.limit,
          slag_id: this.listSlagSelect,
          content_id: this.listContentSelect,
          words: this.freeword,
        },
      };
      this.getListUser(formData);
    },
    scrollContent() {
      if (
        Math.round(
          document.getElementsByClassName("multiselect__content-wrapper")[0]
            .scrollTop +
            document.getElementsByClassName("multiselect__content-wrapper")[0]
              .clientHeight
        ) ===
        document.getElementsByClassName("multiselect__content-wrapper")[0]
          .scrollHeight
      ) {
        this.loadingContent = true;
        const requestContent = {
          data: {
            shop_id: this.shop_id,
          },
          page: this.page,
        };
        this.page += 1;
        this.getListContent(requestContent);
      }
    },
    clickScrollContent() {
      document
        .getElementsByClassName("multiselect__content-wrapper")[0]
        .addEventListener("scroll", this.scrollContent);
    },
    async csvExport(datas, dataRequest) {
      const url = `/${Urls.ADMIN}/${Urls.USER}/${Urls.EXPORT}`;
      const method = "POST";
      let response = await Api.adminRequestServer({
        method,
        url,
        data: dataRequest,
      });
      var { data } = response.data;
      if (data.success === false) return datas;
      datas += data.data;
      this.index++;
      if (this.index % Constants.LIMIT_CSV == 0) {
        const getDate = new Date();
        const nameExcel =
          "ユーザー管理" +
          [
            getDate.getFullYear(),
            getDate.getMonth() + 1,
            getDate.getDate(),
          ].join("_") +
          " " +
          [getDate.getHours(), getDate.getMinutes(), getDate.getSeconds()].join(
            ":"
          );
        const CSVName = nameExcel + ".csv";
        let file =
          "姓,姓,メールアドレス,生年月日,郵便番号,都道府県,市区町村,町名,住所,建物名・部屋番号,電話番号,ステータス,会員登録日時,最終ログイン日時,スラグ設定,コンテンツ設定\n";
        file += datas;
        datas = [];
        file = new Encoding.stringToCode(file);
        file = Encoding.convert(file, "sjis", "unicode");
        file = new Uint8Array(file);
        var fileURL = window.URL.createObjectURL(
          new Blob([file], { type: "text/csv;charset=sjis" })
        );
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", CSVName);
        document.body.appendChild(fileLink);
        fileLink.click();
      }
      return datas;
    },
    async exportCSV() {
      this.messageError = {};
      this.messageResponse = "";
      this.messagerErr = "";
      try {
        this.index = 0;
        var datas = [];
        var content_id = [];
        var slag_id = [];
        this.contentExport.forEach((item) => {
          if (item.value) {
            content_id.push(item.value);
          }
        });
        this.slagExport.forEach((item) => {
          if (item.value) {
            slag_id.push(item.value);
          }
        });
        let dataRequest = {
          shop_id: this.shop_id,
          type: this.selected,
          content_id: content_id,
          slag_id: slag_id,
        };
        datas = await this.csvExport(datas, dataRequest);
        if (Object.keys(datas).length == 0) {
          if (this.index == 0) {
            this.messageResponse = "データがありません";
            this.$toasted.error(this.messageResponse);
            this.$store.commit("set", ["message", ""]);
            this.$store.commit("set", ["error", false]);
          } else {
            this.messageSuccess = "ダウンロードが完了しました";
          }

          return;
        }
        const getDate = new Date();
        const nameExcel =
          "ユーザー管理" +
          [
            getDate.getFullYear(),
            getDate.getMonth() + 1,
            getDate.getDate(),
          ].join("_") +
          " " +
          [getDate.getHours(), getDate.getMinutes(), getDate.getSeconds()].join(
            ":"
          );
        const CSVName = nameExcel + ".csv";
        Math.floor(this.index / Constants.LIMIT_CSV) + 1 + ".csv";
        let file =
          "姓,姓,メールアドレス,生年月日,郵便番号,都道府県,市区町村,町名,住所,建物名・部屋番号,電話番号,ステータス,会員登録日時,最終ログイン日時,スラグ設定,コンテンツ設定\n";
        file += datas;
        file = new Encoding.stringToCode(file);
        file = Encoding.convert(file, "sjis", "unicode");
        file = new Uint8Array(file);
        var fileURL = window.URL.createObjectURL(
          new Blob([file], { type: "text/csv;charset=sjis" })
        );
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", CSVName);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.messageSuccess = "ダウンロードが完了しました";
      } catch (e) {
        this.messageResponse = "データがありません";
        this.$toasted.error(this.messageResponse);
        this.$store.commit("set", ["message", ""]);
        this.$store.commit("set", ["error", false]);
        console.log(e);
      }
      this.selected = 1;
      this.$bvModal.hide("modal-export-user");
    },
    modalExportCSV() {
      this.$bvModal.show("modal-export-user");
    },
    returnList() {
      this.$bvModal.hide("modal-export-user");
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-span {
  @media (max-width: 420px) {
    display: none;
  }
}
</style>
